import { Theme } from '@mui/material';
import { TILE_HEIGHT } from 'modules/notifications/constants';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    padding: theme.spacing(1.25, 0),
    minHeight: `${TILE_HEIGHT}px`,
    height: `${TILE_HEIGHT}px`,
    alignItems: 'center',
    cursor: 'pointer',
    borderBottom: `${theme.spacing(0.125)} solid ${theme.palette.background.default}`,

    '&:hover': {
      backgroundColor: theme.palette.notification.tile.hover,
    },
  },

  avatar: {
    display: 'flex',
    justifyContent: 'center',
  },

  notViewed: {
    backgroundColor: theme.palette.notification.tile.unread,
    position: 'relative',

    '&:before': {
      right: 0,
      content: '""',
      position: 'absolute',
      width: theme.spacing(0.85),
      height: '100%',
      backgroundColor: theme.palette.notification.tile.hover,
    },
  },

  message: {
    fontSize: theme.spacing(1.5),
    lineHeight: theme.spacing(2),
    maxHeight: theme.spacing(6),
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '3',
    WebkitBoxOrient: 'vertical',
  },

  date: {
    color: theme.palette.primary.light,
    padding: theme.spacing(0, 1, 0, 1.5),
    fontSize: theme.spacing(1.5),
    textAlign: 'center',
  },

  tooltip: {
    whiteSpace: 'pre-line',
  },
}));
